// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__5pnqm","right":"styles_right__Ty4aU"};